module.exports = __webpack_public_path__ + "static/media/value-prop-frame-2.677a190b.svg";